import _toConsumableArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "theme", "toastOptions"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// ../../../react-shim.js
import React from "react"; // src/index.ts

export * from "@chakra-ui/accordion";
export * from "@chakra-ui/alert";
export * from "@chakra-ui/avatar";
export * from "@chakra-ui/breadcrumb";
export * from "@chakra-ui/button";
export * from "@chakra-ui/checkbox";
export * from "@chakra-ui/close-button";
export * from "@chakra-ui/control-box";
export * from "@chakra-ui/counter";
export * from "@chakra-ui/css-reset";
export * from "@chakra-ui/editable";
export * from "@chakra-ui/form-control";
export * from "@chakra-ui/hooks";
export * from "@chakra-ui/icon";
export * from "@chakra-ui/image";
export * from "@chakra-ui/input";
export * from "@chakra-ui/layout";
export * from "@chakra-ui/media-query";
export * from "@chakra-ui/menu";
export * from "@chakra-ui/modal";
export * from "@chakra-ui/number-input";
export * from "@chakra-ui/pin-input";
export * from "@chakra-ui/popover";
export * from "@chakra-ui/popper";
export * from "@chakra-ui/portal";
export * from "@chakra-ui/progress";
export * from "@chakra-ui/radio";
export * from "@chakra-ui/react-env";
export * from "@chakra-ui/select";
export * from "@chakra-ui/skeleton";
export * from "@chakra-ui/slider";
export * from "@chakra-ui/spinner";
export * from "@chakra-ui/stat";
export * from "@chakra-ui/switch";
export * from "@chakra-ui/system";
export * from "@chakra-ui/table";
export * from "@chakra-ui/tabs";
export * from "@chakra-ui/tag";
export * from "@chakra-ui/textarea";
export * from "@chakra-ui/theme";
export * from "@chakra-ui/toast";
export * from "@chakra-ui/tooltip";
export * from "@chakra-ui/transition";
export * from "@chakra-ui/visually-hidden"; // src/chakra-provider.tsx

import { ChakraProvider as BaseChakraProvider } from "@chakra-ui/provider";
import { theme as defaultTheme } from "@chakra-ui/theme";
import { ToastProvider } from "@chakra-ui/toast";

function ChakraProvider(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme2 = _ref$theme === void 0 ? defaultTheme : _ref$theme,
      toastOptions = _ref.toastOptions,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /* @__PURE__ */React.createElement(BaseChakraProvider, _objectSpread({
    theme: theme2
  }, restProps), children, /* @__PURE__ */React.createElement(ToastProvider, _objectSpread({}, toastOptions)));
} // src/extend-theme.ts


import { theme, isChakraTheme } from "@chakra-ui/theme";
import { isFunction, mergeWith, pipe } from "@chakra-ui/utils";

function extendTheme() {
  for (var _len = arguments.length, extensions = new Array(_len), _key = 0; _key < _len; _key++) {
    extensions[_key] = arguments[_key];
  }

  var overrides = [].concat(extensions);
  var baseTheme = extensions[extensions.length - 1];

  if (isChakraTheme(baseTheme) && overrides.length > 1) {
    overrides = overrides.slice(0, overrides.length - 1);
  } else {
    baseTheme = theme;
  }

  return pipe.apply(void 0, _toConsumableArray(overrides.map(function (extension) {
    return function (prevTheme) {
      return isFunction(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension);
    };
  })))(baseTheme);
}

function mergeThemeOverride() {
  for (var _len2 = arguments.length, overrides = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    overrides[_key2] = arguments[_key2];
  }

  return mergeWith.apply(void 0, [{}].concat(overrides, [mergeThemeCustomizer]));
}

function mergeThemeCustomizer(source, override, key, object) {
  if ((isFunction(source) || isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
    return function () {
      var sourceValue = isFunction(source) ? source.apply(void 0, arguments) : source;
      var overrideValue = isFunction(override) ? override.apply(void 0, arguments) : override;
      return mergeWith({}, sourceValue, overrideValue, mergeThemeCustomizer);
    };
  }

  return void 0;
} // src/theme-extensions/with-default-color-scheme.ts


import { isObject, fromEntries } from "@chakra-ui/utils";

function withDefaultColorScheme(_ref2) {
  var colorScheme = _ref2.colorScheme,
      components = _ref2.components;
  return function (theme2) {
    var names = Object.keys(theme2.components || {});

    if (Array.isArray(components)) {
      names = components;
    } else if (isObject(components)) {
      names = Object.keys(components);
    }

    return mergeThemeOverride(theme2, {
      components: fromEntries(names.map(function (componentName) {
        var withColorScheme = {
          defaultProps: {
            colorScheme: colorScheme
          }
        };
        return [componentName, withColorScheme];
      }))
    });
  };
} // src/theme-extensions/with-default-size.ts


import { isObject as isObject2, fromEntries as fromEntries2 } from "@chakra-ui/utils";

function withDefaultSize(_ref3) {
  var size = _ref3.size,
      components = _ref3.components;
  return function (theme2) {
    var names = Object.keys(theme2.components || {});

    if (Array.isArray(components)) {
      names = components;
    } else if (isObject2(components)) {
      names = Object.keys(components);
    }

    return mergeThemeOverride(theme2, {
      components: fromEntries2(names.map(function (componentName) {
        var withSize = {
          defaultProps: {
            size: size
          }
        };
        return [componentName, withSize];
      }))
    });
  };
} // src/theme-extensions/with-default-variant.ts


import { isObject as isObject3, fromEntries as fromEntries3 } from "@chakra-ui/utils";

function withDefaultVariant(_ref4) {
  var variant = _ref4.variant,
      components = _ref4.components;
  return function (theme2) {
    var names = Object.keys(theme2.components || {});

    if (Array.isArray(components)) {
      names = components;
    } else if (isObject3(components)) {
      names = Object.keys(components);
    }

    return mergeThemeOverride(theme2, {
      components: fromEntries3(names.map(function (componentName) {
        var withVariant = {
          defaultProps: {
            variant: variant
          }
        };
        return [componentName, withVariant];
      }))
    });
  };
} // src/theme-extensions/with-default-props.ts


import { pipe as pipe2 } from "@chakra-ui/utils";

function withDefaultProps(_ref5) {
  var _ref5$defaultProps = _ref5.defaultProps,
      colorScheme = _ref5$defaultProps.colorScheme,
      variant = _ref5$defaultProps.variant,
      size = _ref5$defaultProps.size,
      components = _ref5.components;

  var identity = function identity(t) {
    return t;
  };

  var fns = [colorScheme ? withDefaultColorScheme({
    colorScheme: colorScheme,
    components: components
  }) : identity, size ? withDefaultSize({
    size: size,
    components: components
  }) : identity, variant ? withDefaultVariant({
    variant: variant,
    components: components
  }) : identity];
  return function (theme2) {
    return mergeThemeOverride(pipe2.apply(void 0, fns)(theme2));
  };
}

export { ChakraProvider, extendTheme, mergeThemeOverride, withDefaultColorScheme, withDefaultProps, withDefaultSize, withDefaultVariant };